import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import Relay from 'react-relay';
import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import {Link} from 'react-router';
import {sendError} from '../app/errorDisplayer';
import * as BrowserPermission from '../BrowserPermission';
import * as Permission from '../../common/util/Permission';

import {getProfile} from '../app/auth.js';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'settings.pageTitle', 'defaultMessage': 'Settings'}
});

let ProviderMap = {
    'auth0': 'Auth0',
    'google-oauth2': 'Google',
    'windowslive': 'Microsoft Windows Live',
};

interface SettingsProps {
    intl: IntlShape;
    user: User;
}

class Settings extends React.Component<SettingsProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            profile: false,
        };
    }

    componentWillMount() {
        getProfile().then((profile) => {
            // Success callback
            this.setState({'profile': profile});
        }).catch((e) => {
            sendError(e);
        });
    }

    renderProfile() {

        return (
            <div className="row">
                <div className="hidden-xs col-sm-3">
                    <img src={this.state.profile.picture} style={{width: '100%'}} />
                </div>
                <div className="col-sm-9">
                    <table className="table">
                        <tbody>
                            <tr><th><FormattedMessage defaultMessage="Name" id="settings.name" />: </th><td>{this.props.user.firstname} {this.props.user.surname}</td></tr>
                            <tr><th><FormattedMessage defaultMessage="E-mail" id="settings.email" />: </th><td>{this.props.user.email}</td></tr>
                            {this.props.user.phoneNumber ?
                                <tr><th><FormattedMessage defaultMessage="Phone number" id="settings.phoneNumber" />: </th><td>{this.props.user.phoneNumber}</td></tr>
                                : null}
                            {this.state.profile.identities.map((identity) => {
                                return (<tr key={identity['user_id']}><th><FormattedMessage defaultMessage="Authenticated by" id="settings.authenticatedBy" />: </th><td>{ProviderMap[identity['provider']] ? ProviderMap[identity['provider']] : identity['provider']}</td></tr>);
                            })}
							{this.props.user.otherEmails ? <tr><th><FormattedMessage defaultMessage="Other emails" id="metadata.users.otherEmails" />: </th><td>{this.props.user.otherEmails.split(',').map((email, idx) => <div key={idx}>{email.trim()}</div>)}</td></tr> : null}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        let data = this.props.user;
        let type = types['users'];

        let lastOrganisationId = getLastOrganisationId();
        if (lastOrganisationId) {
            data['organisation_id'] = lastOrganisationId;
        }

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    {data['organisation_id'] ?
                        <DetailToolBar data={data} metadata={type} noEdit organisationId={this.props.user.organisation ? this.props.user.organisation.realId : null} urlMapping={urlMapping}>
							<Link className="btn btn-default" to={urlMapping.getUrl('user', 'edit')}><i aria-hidden="true" className="fa fa-edit"></i>&nbsp; <FormattedMessage defaultMessage="Edit" id="common.edit" /></Link>
                            {BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_ORGANISATION, this.props.user.organisation ? this.props.user.organisation.realId : null) ? <Link className="btn btn-default" to={urlMapping.getUrl(types['organisations'], 'edit', {id: lastOrganisationId})}><i aria-hidden="true" className="fa fa-fw fa-credit-card"></i>&nbsp; <FormattedMessage defaultMessage="Billing info" id="organisations.billing" /></Link> : null}

                            <Link className="btn btn-default" to={urlMapping.getUrl(types['apiKeys'], 'list', {id: this.props.user.id, organisation_id: lastOrganisationId})}><i aria-hidden="true" className="fa fa-fw fa-lock"></i>&nbsp; <FormattedMessage defaultMessage="API Keys" id="apiKeys.list" /></Link>

                            <Link className="btn btn-default" to={urlMapping.getUrl(types['channelErrors'], 'list-user-fail', {id: this.props.user.id, organisation_id: lastOrganisationId})}><i aria-hidden="true" className="fa fa-fw fa-line-chart"></i>&nbsp; <FormattedMessage defaultMessage="Errors" id="ChannelErrors.list" /></Link>
                            <Link className="btn btn-default" to={urlMapping.getUrl('user', 'notifications')}><i aria-hidden="true" className="fa fa-bell"></i>&nbsp; <FormattedMessage defaultMessage="Notifications settings" id="common.notifications" /></Link>
                        </DetailToolBar>
                    : null}
                    <h2><FormattedMessage defaultMessage="My Profile" id="settings.title" /></h2>

                    {this.state.profile ? this.renderProfile() : null}
                </DetailBox>
            </AppPanel>
        );
    }

}

export default Relay.createContainer(injectIntl(Settings), {
    fragments: {
        user: () => Relay.QL`
        fragment on User {
            id,
            realId,
            firstname,
            surname,
			nickname,
            phoneNumber,
			otherEmails,
			email,
			company

        }
    `,
    },
});
